// CensusReview
import ActivityHistory from './CensusReview/pages/ActivityHistoryPage'
import CensusReview from './CensusReview/pages/CensusReview'
import CensusReviewDuplicatePage from './CensusReview/pages/CensusReviewDuplicate'
import CensusReviewUndeterminedPage from './CensusReview/pages/CensusReviewUndetermined'
import CensusReviewRecordsActivity from './CensusReview/pages/CensusReviewRecordsActivity'
import CensusReviewRecordsError from './CensusReview/pages/CensusReviewRecordsError'
import ReviewNewRecords from './CensusReview/pages/ReviewNewRecords'

// CensusManage
import withAuth from '../../hooks/withAuthorization'
import ManageRecords from './pages/CensusManage'
import CompletedPage from './pages/Completed'
import InReviewPage from './pages/InReview'
import ReviewRecordsActivity from './pages/ReviewRecordsActivity'
import ReviewRecordsDraftEmployee from './pages/ReviewRecordsDraftEmployee'
import ReviewRecordsDuplicateEmployee from './pages/ReviewRecordsDuplicate'
import ReviewRecordsError from './pages/ReviewRecordsError'
import ReviewRecordsUpdateEmployeeBenefits from './pages/ReviewRecordsUpdateBenefits'
import ReviewRecordsUpdateEmployeeNoBenefits from './pages/ReviewRecordsUpdateNoBenefits'

import {
  ROLE_CLIENT_ADMIN,
  ROLE_PLATFORM_HIXME_ADMIN,
} from '@hixme/role-policy'
import CensusReviewUpdatesWithBenefits from './CensusReview/pages/CensusReviewUpdatesBenefits'
import CensusReviewUpdatesNoBenefits from './CensusReview/pages/CensusReviewUpdatesNoBenefits'
import { withCensusManagementV2RouteProvider } from './components/withCensusManagementProvider'
import { CENSUS_MANAGEMENT_PATH, CENSUS_REVIEW_PATH } from './constants'
import BulkTerminationsPage from './pages/BulkTerminationsManage'
import FailedTerminationFilePage from './pages/FailedTerminationFilePage'
import TerminationFilePage from './pages/TerminationFilePage'
import TerminationTrackingDashboard from './pages/TerminationTrackingDashboard'

// CensusReview
const CensusReviewWithAuth = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(CensusReview)
const CensusReviewNewRecords = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  ReviewNewRecords
)
const CensusReviewError = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewRecordsError
)
const CensusReviewActivity = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewRecordsActivity
)
const CensusReviewActivityHistory = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  ActivityHistory
)
const CensusReviewUpdatesBenefits = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewUpdatesWithBenefits
)
const CensusReviewUpdateNoBenefits = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewUpdatesNoBenefits
)
const CensusReviewDuplicate = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewDuplicatePage
)
const CensusReviewUndetermined = withAuth([ROLE_PLATFORM_HIXME_ADMIN])(
  CensusReviewUndeterminedPage
)

// HR Admins can view V2 pages, but they are further restricted by a flag
// CensusManage
const Manage = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(ManageRecords)
)
const Error = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(ReviewRecordsError)
)
const Draft = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    ReviewRecordsDraftEmployee
  )
)
const UpdateBenefits = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    ReviewRecordsUpdateEmployeeBenefits
  )
)
const UpdateNoBenefits = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    ReviewRecordsUpdateEmployeeNoBenefits
  )
)
const Duplicate = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    ReviewRecordsDuplicateEmployee
  )
)
const Activity = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    ReviewRecordsActivity
  )
)
const InReview = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(InReviewPage)
)
const Completed = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(CompletedPage)
)

// Bulk Terminations
const TerminationsManage = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(BulkTerminationsPage)
)
const TerminationFileRows = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(TerminationFilePage)
)
const TerminationFailedFiles = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN, ROLE_CLIENT_ADMIN])(
    FailedTerminationFilePage
  )
)
const TerminationTracking = withCensusManagementV2RouteProvider(
  withAuth([ROLE_PLATFORM_HIXME_ADMIN])(TerminationTrackingDashboard)
)

const CensusManagementRoutes = [
  // CensusManage
  {
    path: CENSUS_MANAGEMENT_PATH,
    component: Manage,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/ERROR`,
    component: Error,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/DRAFT_EMPLOYEE`,
    component: Draft,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/UPDATE_EMPLOYEE_BENEFITS`,
    component: UpdateBenefits,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/UPDATE_EMPLOYEE_NO_BENEFITS`,
    component: UpdateNoBenefits,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/DUPLICATE_EMPLOYEE`,
    component: Duplicate,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/activity`,
    component: Activity,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/in-review`,
    component: InReview,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/:importPublicKey/completed`,
    component: Completed,
  },
  // Terminations
  {
    path: `${CENSUS_MANAGEMENT_PATH}/bulk-terminations`,
    component: TerminationsManage,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/bulk-terminations/:importPublicKey`,
    component: TerminationFileRows,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/bulk-terminations/failed/:importPublicKey`,
    component: TerminationFailedFiles,
  },
  {
    path: `${CENSUS_MANAGEMENT_PATH}/termination-tracking`,
    component: TerminationTracking,
  },

  // CensusReview
  {
    path: CENSUS_REVIEW_PATH,
    component: CensusReviewWithAuth,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/DRAFT_EMPLOYEE`,
    component: CensusReviewNewRecords,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/ERROR`,
    component: CensusReviewError,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/activity`,
    component: CensusReviewActivity,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/activity-history`,
    component: CensusReviewActivityHistory,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/UPDATE_EMPLOYEE_BENEFITS`,
    component: CensusReviewUpdatesBenefits,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/UPDATE_EMPLOYEE_NO_BENEFITS`,
    component: CensusReviewUpdateNoBenefits,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/DUPLICATE_EMPLOYEE`,
    component: CensusReviewDuplicate,
  },
  {
    path: `${CENSUS_REVIEW_PATH}/:importPublicKey/UNDETERMINED`,
    component: CensusReviewUndetermined,
  },
]

export default CensusManagementRoutes
